<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<mat-dialog-content>
	<p class="language-modal-description">{{ dialogDescription }}</p>

	<div class="language-modal-content">
		@if (currentUser.loggedIn) {
			<div class="language-item pointer" (click)="toggleLanguageFallback()"
			     [class.active]="showAllTranslations">
				<div class="language-flag">
					<img src="assets/flags/__@2x.png" (error)="onImageError($event)" alt=""/>
				</div>
				<div class="language-name">
					@if (isGerman) {
						Alle Übersetzungen anzeigen
					} @else {
						Show all languages
					}
				</div>
			</div>
		}
		@for (_language of languages; track _language.isocode) {
			@for (_country of _language.countries; track $index) {
				<div class="language-item pointer"
				     [class.active]="!showAllTranslations && _language.isocode === currentLanguage?.isocode && _country === currentCountry"
				     (click)="selectLanguage(_language, _country)">
					<div class="language-flag">
						<img [src]="getFlagIcon(_language, _country)" (error)="onImageError($event)" alt=""/>
					</div>
					<div class="language-name">
						{{ _language.title }}
						@if (_language.countries.length > 1 && _country && _country !== "__") {
							- {{ _country | isoCodeToCountryName }}
						}
					</div>
				</div>
			}
		}
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>{{ cancelButtonText }}</button>
</mat-dialog-actions>
